import { CommonModule } from "@angular/common";
import {
    ChangeDetectionStrategy,
    Component,
    EventEmitter,
    Input,
    Output,
} from "@angular/core";

import { Observable } from "rxjs";

import { CallToActionComponent } from "@hermes/aphrodite/call-to-action";
import { IconButtonComponent } from "@hermes/aphrodite/icon-button";
import {
    registerSvgs,
    svgBackArrow,
    SvgIconComponent,
} from "@hermes/aphrodite/svg";
import { BreakpointService } from "@hermes/utils-generic/services/user-interface";

import {
    computeIconConfiguration$,
    IconConfiguration,
} from "../helpers/icon-button.helpers";

export const PRIMARY = "primary";
export const SECONDARY = "secondary";

export type BackButtonAppearance = typeof PRIMARY | typeof SECONDARY;

@Component({
    selector: "h-back-button",
    standalone: true,
    imports: [
        CommonModule,
        CallToActionComponent,
        IconButtonComponent,
        SvgIconComponent,
    ],
    templateUrl: "./back-button.component.html",
    styleUrls: ["./back-button.component.scss"],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BackButtonComponent {
    /**
     * Controls the appearance of the back button.
     * This property is forwarded to the underlying `h-icon-button` component.
     * - `PRIMARY`: Displays a white background.
     * - `SECONDARY`: Displays no background.
     *
     * Note: The `h-back-button` does not implement its own appearance logic.
     * All styling related to appearance is managed by the `h-icon-button`.
     */
    @Input()
    public appearance: BackButtonAppearance = PRIMARY;

    @Input()
    public shouldInheritHeight: boolean = false;

    @Output()
    public pressed: EventEmitter<void> = new EventEmitter<void>();

    public iconConfiguration$: Observable<IconConfiguration>;

    constructor(private breakpointService: BreakpointService) {
        this.iconConfiguration$ = computeIconConfiguration$(
            this.breakpointService.mediumBreakpointObserver(),
        );
        registerSvgs([svgBackArrow]);
    }

    public handleButtonClicked(): void {
        this.pressed.emit();
    }
}
